export default __webpack_public_path__ + "static/media/parking-icon-active.ef394f2e.svg";